import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Statement } from "@/components/landing/Statement";
import { Categories } from "@/components/landing/Categories";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Working } from "@/components/landing/Working";
import { DreamTeam } from "@/components/landing/DreamTeam";
import { AIAcademy } from "@/components/landing/AIAcademy";
import { Editions } from "@/components/landing/Editions";
import { LifeMeasured } from "@/components/landing/LifeMeasured";
import { Integrations } from "@/components/landing/Integrations";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const { hash } = useLocation();

  // Handle deep-linked section anchors like /#start (used by the Pricing page
  // and Footer). React Router doesn't scroll automatically, so we do it here.
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    // Give the sections a beat to render before scrolling.
    const t = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div data-testid="landing-page" className="relative z-10">
      <Navbar />
      <main>
        <Hero />
        <Statement />
        <Categories />
        <HowItWorks />
        <Working />
        <DreamTeam />
        <AIAcademy />
        <Editions />
        <LifeMeasured />
        <Integrations />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
